// src/api/resenias.js
import api from "./config.js";

// Obtener todas las reseñas
export const getResenias = async () => {
    const { data } = await api.get("/resenias");
    return Array.isArray(data) ? data : data.resenias || [];
};

// Obtener una reseña por ID
export const getResenia = async (id) => {
    const { data } = await api.get(`/resenias/${id}`);
    return data;
};

// Crear una nueva reseña
export const createResenia = async (resenia) => {
    const { data } = await api.post("/resenias", resenia);
    return data;
};

// Actualizar reseña
export const updateResenia = async (id, resenia) => {
    const { data } = await api.put(`/resenias/${id}`, resenia);
    return data;
};

// Eliminar reseña
export const deleteResenia = async (id) => {
    const { data } = await api.delete(`/resenias/${id}`);
    return data;
};
